import { render, staticRenderFns } from "./DialogCommon.vue?vue&type=template&id=3c80c4d5&scoped=true&"
import script from "./DialogCommon.vue?vue&type=script&lang=js&"
export * from "./DialogCommon.vue?vue&type=script&lang=js&"
import style0 from "./DialogCommon.vue?vue&type=style&index=0&id=3c80c4d5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c80c4d5",
  null
  
)

export default component.exports